import { Component, OnInit, HostListener } from '@angular/core';
import { ROUTESPATH } from '@core';
import { Router } from '@angular/router';
import { TokenService } from '@services';

@Component({
  selector: 'app-menu-venta',
  templateUrl: './menu-venta.component.html',
  styleUrls: ['./menu-venta.component.scss']
})
export class MenuVentaComponent implements OnInit {

  menuOpen = false;
  routes = ROUTESPATH;
  public role: string;
  @HostListener('document:click', ['$event'])
  documentClick(event: MouseEvent) {
    if (this.menuOpen) {
      this.menuOpen = false;
    }
  }

  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.role = TokenService.user?.role || '';
  }

  toggleMenu() {
    if (!this.menuOpen) {
      setTimeout(() => {
        this.menuOpen = true;
      }, 10);
    }
  }

  get createProjectRoute() {
    return ROUTESPATH.PROJECT_CLIENT.replace(
      ':idProject', 'none'
    )
  }

  goToPoliciesPending() {
    this.router.navigate([this.routes.POLICY_POLICIES], { queryParams: { status: 'PENDING' } });
  }

  routingPolicies(status: string) {
    this.router.navigate([ROUTESPATH.POLICY_POLICIES], { queryParams: { status } });
  }

  routingProjects(status: string) {
    this.router.navigate([ROUTESPATH.PROJECT_MIS_PROYECTOS], {queryParams: {status}});
  }
}
